import React from 'react';
import { parseISO, format as formatDateFns } from 'date-fns';

interface TimeProps {
  date: string | number | Date;
  format: string; // Accepts date-fns format strings
}

const Time: React.FC<TimeProps> = ({ date, format }) => {
  console.info('Time', date, format);

  let time: Date;

  if (typeof date === 'number') {
    time = new Date(date * 1000); // Convert seconds to milliseconds
  } else if (typeof date === 'string') {
    time = parseISO(date); // Parse ISO string
  } else {
    time = date; // Assume it's already a Date object
  }

  return (
    <time dateTime={time.toISOString()}>{formatDateFns(time, format)}</time>
  );
};

export default Time;
